import { render, staticRenderFns } from "./dangTxt.vue?vue&type=template&id=2cad4aa5&scoped=true"
import script from "./dangTxt.vue?vue&type=script&lang=js"
export * from "./dangTxt.vue?vue&type=script&lang=js"
import style0 from "./dangTxt.vue?vue&type=style&index=0&id=2cad4aa5&prod&lang=scss"
import style1 from "./dangTxt.vue?vue&type=style&index=1&id=2cad4aa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cad4aa5",
  null
  
)

export default component.exports